<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $tc("checklist", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'List Checklists' }">{{
        $tc("checklist", 2)
      }}</router-link>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="checklist_name"
                name="checklist_name"
                v-validate="'required'"
                v-model="checklist_name"
                placeholder="."
              />
              <label>Checklist Name</label>
            </div>
            <!-- <Tooltip :title="$t('checklist_name')" /> -->
          </div>
          <p class="error_message">
            <span v-if="errors.has('checklist_name')">{{
              errors.first("checklist_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <multiselect
              :options="categoryList"
              v-model="selected_category"
              :searchable="true"
              label="cc_name"
              track-by="cc_name"
              placeholder="Checklist Category"
              v-validate="'required'"
              name="selected_category"
              id="selected_category"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>

            <!-- <Tooltip :title="$t('checklist_category')" /> -->
          </div>
          <p class="error_message">
            <span v-if="errors.has('selected_category')">{{
              errors.first("selected_category")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <multiselect
              :options="cinema_list"
              v-model="selected_cinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_name"
              placeholder="Cinema"
              v-validate="'required'"
              name="selected_cinema"
              id="selected_cinema"
              :allowEmpty="false"
              :showLabels="false"
              :disabled="isRoleID"
            ></multiselect>

            <!-- <Tooltip :title="$t('checklist_cinema')" /> -->
          </div>
          <p class="error_message">
            <span v-if="errors.has('selected_cinema')">{{
              errors.first("selected_cinema")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch"> -->
            <b-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="checklist_is_active"
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message"></p>
        </div>

        <div
          class="col-lg-12 col-xl-12 mb-4"
          v-for="(Items, itemIndex) in checkListItems"
          :key="itemIndex"
        >
          <div class="d-flex justify-content-center align-items-center">
            <div class="input-material">
              <input
                type="text"
                step="any"
                v-model="Items.item"
                placeholder="."
              />
              <label>CheckList Item</label>
            </div>
            <div class>
              <button
                v-if="itemIndex === 0"
                @click.prevent.stop="increaseItem()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="decreaseItem(itemIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="editChecklist()"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ChecklistService from "@/services/ChecklistService";
export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      checklist_name: "",
      checklist_is_active: true,
      categoryList: [],
      cinema_list: [],
      selected_category: null,
      selected_cinema: null,

      checkListItems: [],
      removedItems: [],
    };
  },
  mounted() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
    this.getCategoryList();
    this.getChecklistData();
  },
  methods: {
    getChecklistData() {
      const { checklist_id } = this.$route.params;
      ChecklistService.GetChecklistData({ checklist_id: checklist_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              console.log("data.Records :>> ", data.Records);
              (this.checklist_name = data.Records[0].checklist_name),
                (this.selected_cinema = {
                  cine_id: data.Records[0].cine_id,
                  cine_name: data.Records[0].cine_name,
                });

              this.selected_category = {
                checklist_category_id: data.Records[0].checklist_category_id,
                cc_name: data.Records[0].cc_name,
              };

              this.checklist_is_active = data.Records[0].checklist_is_active ==
                "Y";

              data.Records.map((x) => {
                console.log("x.checklist_item :>> ", x.checklist_item);
                this.checkListItems.push({
                  item: x.checklist_item,
                  item_id: x.checklist_item_id,
                });
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    editChecklist() {
      const { checklist_id } = this.$route.params;
      let flag = true;

      this.checkListItems.map((x) => {
        if (x.item == "") {
          flag = false;
          return;
        }
      });
      if (flag == true) {
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.btenable = true;
            // let loader = this.$loading.show();

            // console.log("JSON.stringify :", JSON.stringify(finalObj));
            let payload = {
              checklist_name: this.checklist_name,
              category_id: this.selected_category.checklist_category_id,
              cinema_id: this.selected_cinema.cine_id,
              items_array: this.checkListItems,
              removedItems: this.removedItems,
              checklist_is_active: this.checklist_is_active,
              checklist_id: checklist_id,
            };
            ChecklistService.EditChecklist(payload)
              .then((response) => {
                const { data } = response;
                // loader.hide();
                if (data && data.status) {
                  this.btenable = false;

                  this.$toasted.show(data.message);

                  this.$router.push({
                    path: "/cinema-manager/list-checklists",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          } else {
            this.$toasted.show("Please enter all details");
          }
        });
      } else {
        this.$toasted.show("Please fill all checklist items");
      }
    },
    getCategoryList() {
      ChecklistService.GetCategories2()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.categoryList = data.Records;
            console.log("this.categoryList :>> ", this.categoryList);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getCinemas(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.cinema_list = data.Records;
            console.log("this.cinema_list :>> ", this.cinema_list);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    increaseItem: function () {
      this.checkListItems.push({
        item: "",
      });
    },
    decreaseItem: function (index) {
      if (this.checkListItems[index].item_id) {
        this.removedItems.push(this.checkListItems[index]);
      }
      this.checkListItems.splice(index, 1);
      console.log("this.removedItems :>> ", this.removedItems);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChecklistComponents/editChecklist.vue